"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const dates_1 = require("../../type-checking/dates");
const get_value_1 = require("./get-value");
class DateFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, dates_1.isDateValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getDateFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => (0, dates_1.isOptimizedDateValue)(fieldValue);
        this.getValueFromOptimized = (fieldValue) => (0, get_value_1.getDateValueFromOptimized)(fieldValue);
    }
}
exports.DateFieldValueGetter = DateFieldValueGetter;
